customElements.define(
  "featured-collection-tabs",
  class extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll(".tab-button");
      this.contents = this.querySelectorAll(".tab-content");
      this.indicator = this.querySelector(".tab-indicator");

      this.buttons.forEach((button) => {
        button.addEventListener("click", () => this.switchTab(button));
      });

      const initialActive =
        this.querySelector(".tab-button.active") || this.buttons[0];
      if (initialActive) {
        this.switchTab(initialActive, false);
      }
    }

    switchTab(activeButton, shouldFocus = true) {
      const tabIndex = activeButton.dataset.tab;

      this.buttons.forEach((btn) => btn.classList.remove("active"));
      activeButton.classList.add("active");

      this.contents.forEach((content) => {
        if (content.dataset.tab === tabIndex) {
          content.classList.add("active");
          content.removeAttribute("inert");
        } else {
          content.classList.remove("active");
          content.setAttribute("inert","");
        }
      });

      this.moveIndicator(activeButton);

      const viewAllBtns = this.querySelectorAll('.custom-event-view-all');
      console.log(viewAllBtns)
      const newHref = activeButton.dataset.viewallurl;
     
      if (viewAllBtns.length && newHref) {
        viewAllBtns.forEach(btn => {
          btn.setAttribute('href', newHref);
        });
      }

      const carousel = this.querySelector(
        `#carousel--${this.dataset.sectionId}-${parseInt(tabIndex)}`
      );
      if (carousel && typeof Splide !== "undefined") {
        new Splide(carousel).mount();
      }

      if (shouldFocus) activeButton.focus();
    }

    moveIndicator(button) {
      const rect = button.getBoundingClientRect();
      const parentRect = button.parentElement.getBoundingClientRect();
      this.indicator.style.width = `${rect.width}px`;
      this.indicator.style.left = `${rect.left - parentRect.left}px`;
    }
  }
);